import { Prompt } from '../Prompt/Prompt.component';

interface CancelEditingNewMessagePromptProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CancelEditingNewMessagePrompt: React.FC<CancelEditingNewMessagePromptProps> = ({ open, onConfirm, onCancel }) => {
  return (
    <Prompt
      type="confirmation"
      open={open}
      mainText={'Czy na pewno chcesz odrzucić tworzenie wiadomości?'}
      isBold={true}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default CancelEditingNewMessagePrompt;
